import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { videoURL } from 'src/app/services/base-url';

@Component({
  selector: 'app-seo-workflow',
  templateUrl: './seo-workflow.component.html',
  styleUrls: ['./seo-workflow.component.css']
})
export class SeoWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;
  searchFilter: string = "";

  selectedEpisode: any = null;
  seoForm: any | FormGroup;
  formSubmit: boolean = false;
  cid: any;
  loggedInUserId: any;

  userList: any[] = [];
  videoUrl: any = videoURL
  userType: any = "";


  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.userType = sessionStorage.getItem("userType");
    this.initForm();

    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'EDITOR');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  initForm() {
    this.seoForm = this.fb.group({
      seoUser: [''],
      assignToSEOTeamOnDate: [''],
      seoTeamStartDate: [''],
      seoTeamEndDate: [''],
      suggestedSEOTitles: [''],
      approvedSeoTitle: [''],
      commonNotes: [''],
      episodeYouTubeURL: ['']
    });
  }

  getAllTvProductionTrackersUserId() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllTvProductionTrackersUserId(this.loggedInUserId).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response;
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllEpisodes();
  }

  openSeoModal(episode: any) {
    this.selectedEpisode = episode;
    this.seoForm.patchValue({
      ...episode,
      suggestedSEOTitles: '',
      commonNotes: ''
    });
    this.formSubmit = false;
  }

  closeModal() {
    document.getElementById("closeSeoModalBtn")?.click();
    this.selectedEpisode = null;
    this.seoForm.reset();
  }

  saveDetails(complete: boolean) {
    if (this.seoForm.invalid) {
      this.formSubmit = true;
      this.toastr.error("Please fill required fields");
      return;
    }

    let suggestedSEOTitlesArr = this.selectedEpisode.suggestedSEOTitles || [];
    if (this.seoForm.get('suggestedSEOTitles').value) {
      suggestedSEOTitlesArr.push({
        seoTitleName: this.seoForm.get('suggestedSEOTitles').value
      });
    }

    let commonNotesArr = this.selectedEpisode.commonNotes || [];
    if (this.seoForm.get('commonNotes').value) {
      commonNotesArr.push({
        userId: Number(sessionStorage.getItem('userId')) || 0,
        userName: sessionStorage.getItem('userName') || '',
        commonNotes: this.seoForm.get('commonNotes').value,
        date: new Date().getTime()
      });
    }

    let nextStage = this.selectedEpisode.currentStage;
    if (complete) {
      nextStage = "COMPLETED";
    }

    let finalSeoEndDate = this.seoForm.get('seoTeamEndDate')?.value ? new Date(this.seoForm.get('seoTeamEndDate').value).getTime() : 0;
    if (complete) {
      finalSeoEndDate = new Date().getTime();
    }

    const payload: any = {
      ...this.selectedEpisode,
      commonNotes: commonNotesArr,
      seoUser: this.seoForm.get('seoUser').value,
      assignToSEOTeamOnDate: this.seoForm.get('assignToSEOTeamOnDate').value ? new Date(this.seoForm.get('assignToSEOTeamOnDate').value).getTime() : (this.selectedEpisode.assignToSEOTeamOnDate || 0),
      seoTeamStartDate: this.seoForm.get('seoTeamStartDate').value ? new Date(this.seoForm.get('seoTeamStartDate').value).getTime() : this.selectedEpisode.seoTeamStartDate,
      seoTeamEndDate: finalSeoEndDate,
      suggestedSEOTitles: suggestedSEOTitlesArr,
      approvedSeoTitle: this.seoForm.get('approvedSeoTitle').value,
      episodeYouTubeURL: this.seoForm.get('episodeYouTubeURL').value,
      episodeStatus: complete ? 'COMPLETED' : this.selectedEpisode.episodeStatus,
      currentStage: nextStage,
      publishingUser: this.selectedEpisode.publishingUser,
      assignToPublishingTeamOnDate: this.selectedEpisode.assignToPublishingTeamOnDate,
      publishingStartDate: this.selectedEpisode.publishingStartDate,
      cid: this.cid
    };
    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Workflow updated successfully');
        this.getAllEpisodes();
        if (complete) {
          this.closeModal();
        } else {
          this.selectedEpisode.suggestedSEOTitles = suggestedSEOTitlesArr;
          this.selectedEpisode.commonNotes = commonNotesArr;
          this.selectedEpisode.approvedSeoTitle = payload.approvedSeoTitle;
          this.seoForm.patchValue({
            suggestedSEOTitles: '',
            commonNotes: ''
          });
        }
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating workflow');
      }
    );
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }

  sendChat() {
    const noteText = this.seoForm.get('commonNotes')?.value;
    if (!noteText) {
      return;
    }

    const payload = {
      userId: Number(sessionStorage.getItem('userId')) || 0,
      userName: sessionStorage.getItem('userName') || '',
      commonNotes: noteText,
      date: new Date().getTime()
    };

    this.tvProductionTrackerService.updateCommonNotes(this.selectedEpisode.tvProductionTrackerId, payload).subscribe(
      (res: any) => {
        let commonNotesArr = this.selectedEpisode.commonNotes || [];
        commonNotesArr.push(payload);
        this.selectedEpisode.commonNotes = commonNotesArr;
        this.seoForm.patchValue({ commonNotes: '' });
      },
      (err: any) => {
        this.toastr.error('Error sending chat');
      }
    );
  }
}
